// extracted by mini-css-extract-plugin
export default {"tabs":"Operation_tabs__V9bII","content":"Operation_content__kPd8G"};